import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { StoryFacade } from "@hermes/states/story-state";

@Injectable()
export class StoryPageResolver {
    constructor(private storyFacade: StoryFacade) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
        const storyPath = this.getStoryPathFromRouter(route);
        this.storyFacade.fetchStory(storyPath, route.queryParams.s);
        // Resolve only when it's not loading.
        return this.storyFacade.selectLoadingWhenFalse();
    }

    private getStoryPathFromRouter = (route: ActivatedRouteSnapshot): string =>
        [route.parent?.url[route.parent?.url.length - 1], ...route.url]
            .join("/")
            // Remove trailing slash
            .slice(0, -1);
}
